<template>
    <div class="about-box" id="about-box">
        <!-- <title-nav v-if="$store.state.userAgent === 'Mobile'"/> -->
        <title-nav />
        <div class="content">
            <div v-for="(list,index) in lists" :key="index">
                <div class="title">{{ list.question }}</div>
                <div class="answer">{{ list.answer }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import TitleNav from '../../components/nav/TitleNav.vue'
const seo = require('../../../config/index')

export default {
  name: 'Vision',
  components: {
    TitleNav
  },
  mounted(){
    // if(this.$store.state.userAgent !== 'Mobile'){
    //     document.getElementById("about-box").style.cssText= 'margin-top: 98px;height:100%';
    // }
  },
  data(){
      return {
        lists: seo.config.aboutUs
      }
  },
  methods:{
    aboutUs(){

    }
  },
  props:{

  }
}
</script>

<style scoped lang="scss">
.about-box {
    background: #fff;
    .content {
        margin: 0px 10px 0px;
        padding-top: 60px;
        padding-bottom: 10px;
        div {
            padding:5px 0;
        }
        .title {
            text-align: left;
            font-size: 22px;
        }
        .answer {
            text-align: left;
            color: rgba(0,0,0,0.5)
        }
    }
}
</style>
